import { $Qll } from './query-selector';
import { dataToggle } from './toggle-dataset';

export function openAccordion(parent) {
  const yOffset = -130;
  $Qll('.accordion-item__button', parent || document).forEach((item) => {
    // eslint-disable-next-line no-unused-vars
    item.addEventListener('click', (e) => {
      const y = item.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });

      const parent = item.closest('.accordions');
      if (!parent.classList.contains('accordions')) {
        return;
      }

      const isToggle = JSON.parse(parent.dataset.toggle);
      if (isToggle) {
        // eslint-disable-next-line no-use-before-define
        closeAll('.accordion-item', parent);
        // eslint-disable-next-line no-use-before-define
        closeElement(item, true);
        return;
      }
      dataToggle(item, false);
    });
  });
}
function closeElement(ele, state = false) {
  ele.setAttribute('data-active', state);
}

/**
 * Loop to change all dataset active in button accordions
 *
 * @param {String} nodeAll - Reference to search in parent element
 * @param {HTMLElement} parent - Parent to valuate
 * @returns Action to change dataset active to ‘false" at all buttons
 */
export function closeAll(nodeAll, parent) {
  return (
    $Qll(nodeAll, parent)
      // eslint-disable-next-line no-return-assign
      .forEach(
        (node) =>
          // eslint-disable-next-line no-param-reassign
          (node.children[0].dataset.active = 'false')
      )
  );
}
